import { useRegionalOverviewStore } from '@features/regional-overview/regional-overview.store';
import MockedDataAlertComponent, { type MarginStyle } from './mocked-data-alert.component';

interface MockedDataAlertContainerProps {
  style?: MarginStyle;
}
const MockedDataAlertRegionalContainer = ({ style }: MockedDataAlertContainerProps) => {
  const { isDemo, hasShiftData } = useRegionalOverviewStore();
  return <MockedDataAlertComponent isDemo={isDemo} hasShiftData={hasShiftData} style={style} />;
};

export default MockedDataAlertRegionalContainer;
